import {
  getDataMapFromCommonResponse,
  getMessageMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithoutParams, postSPDataWithoutParams } from './services'

function getResponseMessage(response, fallbackMessage) {
  return (
    getMessageMapFromCommonResponse(response) ||
    response?.response?.data?.message ||
    response?.data?.message ||
    response?.message ||
    fallbackMessage
  )
}

export async function getSupportCustomCommunicationsBootstrap() {
  const response = await getSPDataWithoutParams('/api/secure/cc/support/custom-communications/bootstrap')

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.customCommunications || null,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    data: null,
    message: getResponseMessage(response, 'Unable to load custom communications.'),
    rawResponse: response,
  }
}

export async function dispatchSupportCustomCommunication(sendPath, payload = {}) {
  const response = await postSPDataWithoutParams(sendPath, payload)

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.dispatch || null,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    data: null,
    message: getResponseMessage(response, 'Unable to send custom communication.'),
    rawResponse: response,
  }
}

export async function getSupportPractitionerCommunicationsBootstrap(params = {}) {
  const query = new URLSearchParams()
  if (params.practitionerId) query.set('practitioner-id', params.practitionerId)
  if (params.practitionerSlug) query.set('practitioner-slug', params.practitionerSlug)
  const suffix = query.toString() ? `?${query.toString()}` : ''
  const response = await getSPDataWithoutParams(
    `/api/secure/cc/support/practitioner-communications/bootstrap${suffix}`,
  )

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.practitionerCommunications || null,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    data: null,
    message: getResponseMessage(response, 'Unable to load practitioner communication options.'),
    rawResponse: response,
  }
}

export async function sendSupportPractitionerTherapyReportReminder(payload = {}) {
  const response = await postSPDataWithoutParams(
    '/api/secure/cc/support/practitioner-communications/therapy-report-reminder',
    payload,
  )

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.dispatch || null,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    data: null,
    message: getResponseMessage(response, 'Unable to send therapy report reminder.'),
    rawResponse: response,
  }
}

export async function sendSupportPractitionerPayoutReportCommunication(payload = {}) {
  const response = await postSPDataWithoutParams(
    '/api/secure/cc/support/practitioner-communications/payout-report',
    payload,
  )

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.dispatch || null,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    data: null,
    message: getResponseMessage(response, 'Unable to send payout report communication.'),
    rawResponse: response,
  }
}

export async function sendSupportPractitionerGenericCommunication(payload = {}) {
  const response = await postSPDataWithoutParams(
    '/api/secure/cc/support/practitioner-communications/generic',
    payload,
  )

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.dispatch || null,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    data: null,
    message: getResponseMessage(response, 'Unable to send practitioner communication.'),
    rawResponse: response,
  }
}
